import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Valeria R.',
    role: 'Mamá soltera, diseñadora freelance',
    image: 'https://cdn.magicpatterns.com/uploads/3fbPx3GZa4QUnj2aShg9DV/testimonio_1_Valeria_R.png',
    quote: 'Llevaba dos años queriendo lanzar algo propio pero siempre encontraba una excusa. La tecnología me frenaba, no sabía qué precio cobrar y sentía que necesitaba más tiempo. Con el Método IDEA arranqué en 6 días. En mi primera semana conseguí 2 clientes y recuperé lo que pagué por la guía el mismo día que la descargué.'
  }, {
    name: 'Carlos M.',
    role: 'Padre de familia, empleado con ingresos variables',
    image: 'https://cdn.magicpatterns.com/uploads/uKexoBhLynwm6L1tzzAx96/testimonio_2_carlos.png',
    quote: 'Probé cursos caros, videos de YouTube y hasta un mentor que no me dio resultados. Esta guía fue diferente porque es directa y sin relleno. La plantilla de validación me ayudó a probar mi idea en un día sin gastar nada. Al séptimo día ya tenía mi primer ingreso extra. No lo esperaba tan rápido.'
  }, {
    name: 'Patricia S.',
    role: 'Trabajadora independiente, ingresos irregulares',
    image: 'https://cdn.magicpatterns.com/uploads/emBWhBHw5S5wQp292yBmty/tetimonio_3_patricia.png',
    quote: 'Pensé que esto no era para mí porque no soy muy buena con la tecnología y tengo más de 40. Pero el checklist de 7 días lo explica todo tan claro que no tuve que adivinar nada. Seguí los pasos, lancé mi servicio de organización de espacios y ya tengo 3 clientes fijos. Por fin siento que tengo control sobre mis ingresos.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-brand-light text-slate-900" data-id="element-178">
      <div className="max-w-6xl mx-auto" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-180">
          <span className="inline-block py-1.5 px-4 rounded-full bg-brand-accent/10 text-brand-accent text-xs font-bold tracking-wider uppercase mb-4 border border-brand-accent/20" data-id="element-181">
            Historias reales
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-182">
            Personas como tú ya están viendo resultados
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-183">
            Esto es lo que dicen quienes aplicaron el Método IDEA Rápida.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-184">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-slate-200 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col relative" data-id="element-185">
              {/* Quote icon */}
              <div className="absolute -top-4 left-8 bg-brand-accent rounded-full p-2 shadow-lg" data-id="element-186">
                <Quote className="w-4 h-4 text-white" data-id="element-187" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4 mt-2" data-id="element-188">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-secondary text-brand-secondary" data-id="element-189" />)}
              </div>

              {/* Quote */}
              <p className="text-slate-700 leading-relaxed mb-6 flex-grow italic" data-id="element-190">
                "{t.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-slate-100" data-id="element-191">
                <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-brand-accent/20" data-id="element-192" />
                <div data-id="element-193">
                  <p className="font-bold text-slate-900" data-id="element-194">{t.name}</p>
                  <p className="text-sm text-slate-500" data-id="element-195">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}